module.exports = __webpack_public_path__ + "83bc8db20e955029472c535b8a782841.pdf";